import { render, staticRenderFns } from "./BaseHeadingOtherAction.vue?vue&type=template&id=3820659a&scoped=true"
import script from "./BaseHeadingOtherAction.vue?vue&type=script&lang=js"
export * from "./BaseHeadingOtherAction.vue?vue&type=script&lang=js"
import style0 from "./BaseHeadingOtherAction.vue?vue&type=style&index=0&id=3820659a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3820659a",
  null
  
)

export default component.exports